import { FC, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getAttendeesList } from "../../api/common";
import StatusTag from "../../Components/StatusTag";
import Auditor from "../../icons/Auditor.svg?react";
import Auditee from "../../icons/Auditee.svg?react";
import TableContainer from "../../Components/Table";
import { toTitleCase } from "../../utils";
import Alert from "../../Components/AlertPopup";
import Audit from "../../icons/Audit.svg?react";
interface StatePorps {
  onClose: (data: any) => void;
  showModal?: boolean;
  auditId: string;
}

const ShowAttendees: FC<StatePorps> = ({
  showModal = false,
  onClose,
  auditId,
}) => {
  const [showToast, setShowToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState<number>(10); // Default page size
  const [currentPage, setCurrentPage] = useState<number>(1);
  const handleClose = () => {
    setShowToast(false);
    onClose(false);
  };
  const handleErrorClose = () => setShowErrorToast(false);

  useEffect(() => {
    if (auditId) {
      setLoading(true);
      getAttendeesList(parseInt(auditId)).then((response) => {
        if (response) {
          let i = 1;
          const finalSet: any[] = [];
          response.forEach((element: any) => {
            const status =
              element.acceptanceStatus === "none"
                ? "pending"
                : element.acceptanceStatus;
            finalSet.push({
              ...element,
              attendeeName: (
                <span className="d-flex align-items-center gap-2 attendeeIcons">
                  {/* Conditionally render icon based on type */}
                  {element.attendeeType === "Auditor" && <Auditor />}
                  {element.attendeeType === "Auditee" && <Auditee />}
                  <span>{element.attendeeName}</span>
                </span>
              ),
              status: (
                <StatusTag
                  status={status}
                  label={toTitleCase(status)}
                ></StatusTag>
              ),
              no: i,
            });
            i++;
          });
          setRowData(finalSet);
          setLoading(false);
        }
      });
    }
  }, [auditId]);


  const columnData = [
    { label: "No", key: "no" },
    { label: "Attendee Name", key: "attendeeName", alignText: "start" },
    { label: "Attendee Email", key: "attendeeEmail", alignText: "start" },
    { label: "Acceptance Status", key: "status" },
  ];
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handlePageSizeChange = (newLimit: number) => {
    setPageSize(newLimit);
    setCurrentPage(1); // Reset to first page on limit change
  };
  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  const currentScheduled = rowData.slice(indexOfFirstItem, indexOfLastItem);
  return (
    <>
      <Modal size="lg" show={showModal} onHide={() => onClose(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Alert
              show={showErrorToast}
              type="error"
              onClose={handleErrorClose}
              message={ErrorMessage}
            />

            <Alert
              show={showToast}
              onClose={handleClose}
              message={"Kickoff meeting scheduled successfully!!"}
            />
            <div className="modalTitle">
              <Audit style={{ width: "25px", height: "25px", marginBottom: "5px" }} />
              &nbsp;Kickoff Meeting - Attendees
            </div>
          </Modal.Title>
        </Modal.Header>
        <br />
        <Modal.Body>
          <TableContainer
            columnData={columnData}
            rowData={currentScheduled}
            totalResult={rowData.length}
            title={"List of Attendees"}
            enableActionButton={false}
            enableFilter={false}
            itemsPerPage={pageSize}
            showLoading={loading}
            showHeader={false}
            currentPage={currentPage}
            setCurrentPage={(pageNumber) => {
              setCurrentPage(pageNumber);
            }}
            onPageNoChange={handlePageChange}
            onPageLimitChange={handlePageSizeChange}
          />
        </Modal.Body>

        <br />
      </Modal>
    </>
  );
};

export default ShowAttendees;
